import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './Register.css';

async function createUser(credentials) {
  return await fetch(`${process.env.REACT_APP_API_URL}/user/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  })
    .then(data => data.json());
}

export default function Register({ setAccessToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const handleSubmit = async e => {
    e.preventDefault();
    const accessToken = await createUser({
      username,
      password,
    });
    setAccessToken(accessToken);
    window.location.href = '/';
  };

  return (
    <div className="register-wrapper">
      <h1>New User's Registration Form</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <p>Username</p>
          <input type="text" onChange={e => setUserName(e.target.value)} />
        </label>
        <label>
          <p>Password</p>
          <input type="password" onChange={e => setPassword(e.target.value)} />
        </label>
        <div>
          <button type="submit">Register</button>
        </div>
      </form>
    </div>
  );
}

Register.propTypes = {
  setAccessToken: PropTypes.func.isRequired,
};